import { PaChatLauncher } from '@formant/chat';

import { renderMemoryToolCall } from './host-seams';

/**
 * Header-bar entry point for ad-hoc chat — a floating dialog summonable from
 * anywhere off the `/chat` surface (mounted in `__root` for FDE users). Renders
 * the canonical `@formant/chat` floating launcher (PA-only) inside the host
 * provider, feeding the console's memory-card + fleet-viz tool-render seams.
 *
 * Legacy theopolis threads are intentionally absent here: they are a `/chat`-page
 * concern (DEV-16991 §7), where they flow in as the package's `extraThreadRows`.
 * The floating launcher is always the persistent-agent runtime.
 */
export function ChatLauncher() {
  return <PaChatLauncher renderToolCall={renderMemoryToolCall} />;
}
